import { randomizeUserPic } from '../randomizeUserPic';

export const getPersonaUserPic = (usedImg: string[]) => {
	let img = randomizeUserPic();
	if (usedImg.includes(img)) {
		img = getPersonaUserPic(usedImg);
	}
	return img;
};
